// extracted by mini-css-extract-plugin
export default {"container":"TipAmountSelector_container__a+Ll9"};